<script>
	import { createEventDispatcher } from 'svelte';
	import { replace } from 'svelte-spa-router';
	import { 
		gerarStringAleatoria, 
		StatusHttp, 
		TipoEvento,
		cabecalhoPadraoRequisicao,
		API, TextoFeedback} from '../../utils';
	import { sCaptcha } from '../../stores';
	import TBox from '../templates/TBox.svelte';
	import Captcha from '../../componentes/Captcha.svelte';

	const dispatch = createEventDispatcher();
	
	// variáveis para trabalhar com os dados do formulário
	let titulo, intencao, captchaUsuario;
	let formularios = [];
	const valoresCheckbox = [
		{ chave: 'MON', valor: 'Monitoria' },
		{ chave: 'ID', valor: 'Iniciação à Docência' },
		{ chave: 'EIC', valor: 'Estágio Interno Complementar' },
		{ chave: 'RELATORIO_DISCENTE', valor: 'Relatório Final Discente' },
		{ chave: 'RELATORIO_COORDENADOR', valor: 'Relatório Final Coordenador(a)' },
		{ chave: 'APRESENTACAO_SEMANA_GRADUACAO', valor: 'Apresentação de trabalho na Semana de Graduação' }
	];

	let tituloAviso = "Erro";
	let feedbackUsuario = [];
	let informacoesAPI = [];

	async function submeterFormulario(event) {
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Enviando os dados ...',
		});
			
		if (captchaUsuario != $sCaptcha) {
			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Captcha Inválido',
				conteudo: 'O código informado é inválido, tente novamente.'
			});
			
			// atualiza o store
			sCaptcha.update(novaString => gerarStringAleatoria());
		} else {
			// faz a chamada a API no endpoint cadastrar, envia os dados e aguarda a resposta
			const resposta = await fetch(API('afirmacoes'), {
				method: 'POST',
				headers: cabecalhoPadraoRequisicao(),
				body: JSON.stringify({
					titulo: titulo,
					intencao: intencao,
					formularios: formularios,
				})
			}).catch(erros => {
				console.log(erros);

				feedbackUsuario.push(TextoFeedback.ERRO_REQUISICAO);
				
				dispatch('routeEvent', { 
					tipo: TipoEvento.ESTA_CARREGANDO,
					valor: false
				});
				
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: tituloAviso,
					conteudo: feedbackUsuario[0]
				});
			});

			// pega o json do retorno da resposta
			const json = await resposta.json();

			if (resposta.status == StatusHttp.CREATED) {		
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: 'Tudo certo!',
					conteudo: 'Afirmação cadastrada com sucesso.'
				});

				replace('/painel');
			} else if (resposta.status == StatusHttp.UNPROCESSABLE_ENTITY) {
				tituloAviso = 'Verifique os dados informados!'
				feedbackUsuario.push(json?.mensagem);
			} else {
				feedbackUsuario.push(json?.mensagem ?? 'Erro desconhecido, se persistir, favor entrar em contato.');
			}

			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});

			// exibe feedback pro usuário se existir algo pra exibir
			if (feedbackUsuario[0]) {
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: tituloAviso,
					conteudo: feedbackUsuario[0]
				});
			}

			// limpa as mensagens
			feedbackUsuario = [];
		}

	}
</script>

<TBox 
	titulo="Banco de Afirmações" 
	subtitulo="Base de afirmações para criação de formulário de avaliação" 
	largura="8" 
	deslocamento="2" 
	correcaoY="-13px"
	icone="banco_afirmacoes">
	
	<form method="post" on:submit|preventDefault={submeterFormulario}>
		<div class="columns">
			<div class="column is-full">
				<div class="field">
					<input 
						bind:value={titulo}
						name="titulo" 
						type="text" 
						placeholder="Título da afirmação. O que se quer avaliar." 
						class="input is-large is-primary" required>
				</div>
			</div>
		</div>

		<div class="columns">
			<div class="column is-half">
				<div class="field">
					<p class="is-size-4">Formulários</p>
					<p class="is-size-6 is-italic mb-3">Em quais formulários este ítem deverá ser utilizado.</p>

					{#each valoresCheckbox as { chave, valor }}
					<label class="checkbox">
						<input type="checkbox" bind:group={formularios} value="{chave}">
						{valor}
					</label>
					<br>
					{/each}
				</div>
			</div>

			<div class="column is-half">
				<div class="field">
					<p class="is-size-4">Intenção</p>
					<p class="is-size-6 is-italic mb-3">Esta opção determina a inversão ou não da escala de Likert.</p>
					<div class="control">
						<label class="radio">
							<input type="radio" bind:group={intencao} name="intencao" value="POSITIVA"> Positiva
						</label>
						<br>
						<label class="radio">
							<input type="radio" bind:group={intencao} name="intencao" value="NEGATIVA"> Negativa
						</label>
					</div>
				</div>
			</div>
		</div>

		<div class="columns is-mobile">
			<div class="column">
				<Captcha />
			</div>
			<div class="column">
				<input 
					name="captcha"
					bind:value={captchaUsuario}
					type="text"
					maxlength="8" 
					placeholder="Digite o código aqui" 
					class="input is-large is-primary" required>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<p class="control">
					<a href="#/" class="button is-black is-medium is-outlined is-fullwidth">Início</a>
				</p>
			</div>
			<div class="column is-8">
				<p class="control">
					<button 
						type="submit" 
						class="button is-primary is-medium is-fullwidth">
						Cadastrar
					</button>
				</p>
			</div>
		</div>
	</form>
</TBox>